import { useToast } from '@/components/atoms/Toast';
import { dashboardEditListRequest } from '@/modules/dashboard/dashboardActions';
import type { List } from '@/modules/dashboard/dashboardTypes';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

export const useEditListNameMutation = () => {
	const { toast } = useToast();
	const dispatch = useDispatch();

	const mutate = useCallback(
		(list: List) => {
			try {
				dispatch(
					dashboardEditListRequest({ listId: list.id, ...list })
				);

				toast({
					title: `List renamed to ${list.name}`,
					variant: 'success'
				});
			} catch (error) {
				toast({
					title: `Something went wrong with list ${list.name}`,
					variant: 'error'
				});
			}
		},
		[dispatch, toast]
	);

	return { mutate };
};
